"use client";

import { useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";
import Image from "next/image";
import Link from "next/link";

import "../styles/auth.css";

const imageMap = {
  "/auth/login": {
    image: "/images/login_image.jpg",
    title: "92+ Ready Modules",
    subtitle: "We're Excited to Have You Back!",
  },
  "/auth/register": {
    image: "/images/signup_page3.png",
    title: "Get Started",
    subtitle: "Join the best payroll solution for modern businesses.",
  },
  "/auth/reset-password": {
    image: "/images/reset_password.JPG",
    title: "92+ Ready Modules",
    subtitle:
      "For your account's security, please choose a strong password.",
  },
  "/auth/forget-password": {
    image: "/images/forgot_password.jpg",
    title: "92+ Ready Modules",
    subtitle:
      "Forgot your password? Don't worry, click on send reset link to create another password.",
  },
  "/auth/otp-verification": {
    image: "/images/verification_image.png",
    title: "92+ Ready Modules",
    subtitle: "You're one step closer to managing your payroll.",
  },
};

export default function AuthWrapper({ children, token }) {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (token) {
      const orgId = localStorage.getItem("selectedOrgId");
      router.replace(orgId ? "/dashboard" : "/auth/select-organisation");
    }
  }, [token, router]);

  const content = imageMap[pathname] || imageMap["/auth/login"];

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Left Column */}
        <div className="col-12 col-md-6">
          <div className="left-column pt-3 pt-md-8 px-3 px-md-0">
            <div className="logo-wrapper">
              <Link href="/">
                <img
                  src="/images/avetiumlogo.png"
                  alt="logo"
                />
              </Link>
            </div>
            <div>{children}</div>
          </div>
        </div>

        {/* Right Column */}
        <div className="col-md-6 px-3 py-0">
          <div className="red-bg text-center px-5 pb-5">
            <Image
              src={content.image}
              alt="Auth Illustration"
              width={600}
              height={400}
              priority
              className="img-fluid"
              style={{ 
                width: "100%", 
                height: "auto",
                maxHeight: "70vh",
                objectFit: "contain"
              }}
            />
            <div className="beneath-image mt-3 text-light">
              <h5>{content.title}</h5>
              <p>{content.subtitle}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}